/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkProjectCheckOverviewDto } from '../models/work-project-check-overview-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectChecksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectChecksV2ControllerFindOverviewByProjectId()` */
  static readonly ProjectChecksV2ControllerFindOverviewByProjectIdPath = '/v2/project-checks/project/{projectId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectChecksV2ControllerFindOverviewByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectChecksV2ControllerFindOverviewByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckOverviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectChecksV2Service.ProjectChecksV2ControllerFindOverviewByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckOverviewDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectChecksV2ControllerFindOverviewByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectChecksV2ControllerFindOverviewByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckOverviewDto> {
    return this.projectChecksV2ControllerFindOverviewByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckOverviewDto>): WorkProjectCheckOverviewDto => r.body)
    );
  }

}
